export const FILE_SIZE_WARN_BYTES = 5 * 1024 * 1024
export const FILE_SIZE_BLOCK_BYTES = 10 * 1024 * 1024
export const VIDEO_SIZE_BLOCK_BYTES = 20 * 1024 * 1024
export const LOGO_SIZE_BLOCK_BYTES = 3 * 1024 * 1024

export interface FileSizeLimits {
  warnBytes: number
  blockBytes: number
}

export const DEFAULT_FILE_SIZE_LIMITS: FileSizeLimits = {
  warnBytes: FILE_SIZE_WARN_BYTES,
  blockBytes: FILE_SIZE_BLOCK_BYTES,
}

export const VIDEO_FILE_SIZE_LIMITS: FileSizeLimits = {
  warnBytes: FILE_SIZE_WARN_BYTES,
  blockBytes: VIDEO_SIZE_BLOCK_BYTES,
}

export const LOGO_FILE_SIZE_LIMITS: FileSizeLimits = {
  warnBytes: LOGO_SIZE_BLOCK_BYTES,
  blockBytes: LOGO_SIZE_BLOCK_BYTES,
}

/**Server rejects request bodies over 30,000,000 bytes, batch below that with headroom for multipart overhead */
export const UPLOAD_BATCH_MAX_BYTES = 25 * 1000 * 1000
export const UPLOAD_BATCH_MAX_FILES = 5
